import React from 'react';
import styles from './container.module.css';

const Container = ({ children, className, title, subtitle }) => {
  return (
    <div className={className || styles.container}>
      {title || subtitle ? (
        <header className={styles.hero}>
          <div className={styles.heroInner}>
            {title ? <h1 className={styles.title}>{title}</h1> : null}
            {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          </div>
        </header>
      ) : null}
      {children}
    </div>
  );
};

export default Container;
